import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from "react-redux"; // Import Provider
import store from "./store/store";      // Import the store (webpack resolves .ts automatically now)
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);

reportWebVitals();